import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

// TODO: It is important to type the below event for dataLayer
/*
  Below is the possible interfaces based on the analysis of the project

  interface CustomEventForAddCustomGaEvent {
    event: string;
    link_text?: string;
    return_type?: string;
    checkout_step_name?: string;
  }

  interface CustomEventForPushAnalyticsEvent {
    event: string;
    web_user_id: string;
    web_account_id: string;
    web_account_country: string;
  }

 */

// Keep in sync with the app_name pushed in apps/web/index.html (it runs before ga.js and cannot import this).
const ANALYTICS_APP_NAME = 'web';

export function useAnalytics() {
  function pushAnalyticsEvent(event: any) {
    window.dataLayer.push({ ...event, app_name: ANALYTICS_APP_NAME });
  }

  function addCustomGaEvent(event: any) {
    if (window && window.dataLayer) {
      window.dataLayer.push({ ...event, app_name: ANALYTICS_APP_NAME });
    }
  }

  function setNewRelicUserId(userId: string) {
    const newRelicAgent: BrowserAgent = window.newrelic;

    if (newRelicAgent) {
      newRelicAgent.setUserId(userId);
    }
  }

  return { pushAnalyticsEvent, addCustomGaEvent, setNewRelicUserId };
}
